import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Firebase configuration for PetPages
const firebaseConfig = {
  apiKey: "AIzaSyCn5ssbEIRsFeiC7refWEP0B-l2x4Tqkr4",
  authDomain: "pet-pages-8273d.firebaseapp.com",
  projectId: "pet-pages-8273d",
  storageBucket: "pet-pages-8273d.firebasestorage.app",
  messagingSenderId: "838969532060",
  appId: "1:838969532060:web:2e6a3737840b1cafa75759"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;
